import * as React from 'react'

import { PropositionBar } from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  PropositionBanner,
  PropositionBannerText,
} from '@thg-commerce/enterprise-widget-proposition-bar'

import { BaseWidgetProps } from '../types'

export type PropositionBarRendererProps = BaseWidgetProps &
  Omit<PropositionBar, 'query'>

export const PropositionBarRenderer = (props: PropositionBarRendererProps) => {
  const textProps: PropositionBannerText[] = [
    props.textOne,
    props.textTwo,
    props.textThree,
    props.textFour,
    props.textFive,
    props.textSix,
  ]
  return <PropositionBanner text={textProps || undefined} />
}
